import React from 'react'

import { Grid, GridProps, Typography, TypographyProps } from '@mui/material'

export const DrawerContent = ({ children, ...props }: GridProps) => {
  return (
    <Grid
      padding="0px 16px"
      container
      flexDirection="column"
      height="100%"
      flexWrap="nowrap"
      sx={{ backgroundColor: (theme) => theme.palette.common.white }}
      {...props}
    >
      {children}
    </Grid>
  )
}

export const DrawerHeader = ({ children, ...props }: GridProps) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      position="sticky"
      top={0}
      zIndex={10}
      paddingY="16px"
      sx={{ backgroundColor: (theme) => theme.palette.common.white }}
      {...props}
    >
      {children}
    </Grid>
  )
}

export const DrawerTitle = ({ children, ...props }: TypographyProps) => {
  return (
    <Typography fontSize="20px" fontWeight="600" lineHeight={1.2} {...props}>
      {children}
    </Typography>
  )
}

export const DrawerStickyFooter = ({ children, sx, ...props }: GridProps) => {
  return (
    <Grid
      mt="auto"
      container
      justifyContent="space-between"
      flexWrap="nowrap"
      gap={2}
      sx={{
        position: 'sticky',
        bottom: 0,
        backgroundColor: (theme) => theme.palette.common.white,
        paddingBottom: '20px',
        marginTop: '20px',
        '&>button': {
          width: '100%',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Grid>
  )
}
